import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { postActivityLog } from '../services/postActivityLog.service';

/**
 * Logs that the current user opened the work-calendar / "Aikaleimat" page
 * (VIEW_TIMESTAMPS). Dispatched by the project-view middleware when the URL is the
 * calendar page. Best-effort (createAsyncThunk routes failures to a `rejected`
 * action). No optimistic latest-projects add — VIEW_PROJECT already handles that
 * for the same project entry.
 */
export const logTimestampsOpened = createAsyncThunk(
  'activityLog/logTimestampsOpened',
  async ({ projectId }, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    return postActivityLog({
      projectId,
      action: 'VIEW_TIMESTAMPS',
      activeEmployerInfo,
    });
  }
);
